import { LOCALES } from 'constants/app-config'

const scheduleIdleTask = (fn) => {
  if (typeof requestIdleCallback === 'function') {
    return requestIdleCallback(fn, { timeout: 8000 })
  }

  return setTimeout(fn, 300)
}

const prefetchKey = (locale, namespaces) => `${locale}:${[...namespaces].sort().join(',')}`

const scheduledKeys = new Set()

/**
 * After active locale namespaces are loaded, prefetch the other chunk locale in idle
 * so language switch can reuse cached chunks / in-memory bundles.
 */
export const scheduleAlternateLocalePrefetch = (loadNamespaces, { activeLocale, namespaces }) => {
  const alternates = LOCALES.filter((locale) => locale !== activeLocale)

  if (!alternates.length || !namespaces?.length) {
    return
  }

  const toPrefetch = alternates
    .map((locale) => ({ locale, namespaces }))
    .filter(({ locale, namespaces: ns }) => {
      const key = prefetchKey(locale, ns)
      if (scheduledKeys.has(key)) {
        return false
      }

      scheduledKeys.add(key)
      return true
    })

  if (!toPrefetch.length) {
    return
  }

  scheduleIdleTask(() => {
    toPrefetch.forEach(({ locale, namespaces: ns }) => {
      loadNamespaces(locale, ns, { emit: false }).catch(() => {})
    })
  })
}
